import { isCancel } from 'axios';

const isRecord = (value: unknown): value is Record<string, unknown> =>
  typeof value === 'object' && value !== null;

const hasServerStatus = (error: Record<string, unknown>): boolean => {
  if (typeof error.status !== 'number') {
    return false;
  }

  if (error.status === 0) {
    return false;
  }

  if (error.status === 502 && !error.errors && !error.response) {
    return false;
  }

  return true;
};

export const isRequestCanceled = (error: unknown): boolean => {
  if (isCancel(error)) {
    return true;
  }

  if (
    typeof DOMException !== 'undefined' &&
    error instanceof DOMException &&
    error.name === 'AbortError'
  ) {
    return true;
  }

  if (!isRecord(error)) {
    return false;
  }

  if (
    error.code === 'ERR_CANCELED' ||
    error.name === 'CanceledError' ||
    error.name === 'AbortError'
  ) {
    return true;
  }

  if (error.code === 'ECONNABORTED' && error.message === 'Request aborted') {
    return true;
  }

  if (hasServerStatus(error)) {
    return false;
  }

  return error.message === 'canceled';
};
